export default __webpack_public_path__ + "static/media/a6b64583bc8e05d25524419c09faca0e1598887900828.1fbefda2.webp";